import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteUserRequestType } from '../types';

export const deleteUser = async ({ bodyParams }: DeleteUserRequestType) => {
  const url = '/api/v2/auth/user';

  const { data } = await apiAuthClient.delete<{ data: '' }>(url, {
    data: bodyParams,
  });

  return data;
};
